<template>
    <div class="drop-orders-container">
        <!-- Сам блок с отображением данными заказа -->
        <div 
            v-for="order in orders" 
            :key="order.id" 
            class="drop-order-block"
        >
            <img 
                :src="order.product_photo_url || require('@/assets/images-templates/пример-фото-товара.jpg')" 
                :alt="order.product_name" 
                class="drop-order-product-img"
            >

            <!-- Блок с отображением данных -->
            <div class="drop-orders-data">
                <!-- Если админский режим - показываем информацию о дроп-пользователе -->
                <div v-if="admin_orders && order.order_type === 'drop'" class="drop-orders-data-line drop-info-line">
                    <div class="drop-order-data-label">Дроп:</div>
                    <div class="drop-order-data-value">
                        {{ order.drop_user_name || 'Неизвестный дроп' }}
                        <span v-if="order.drop_username" class="drop-username"> ({{ order.drop_username }})</span>
                    </div>
                </div>

                <!-- Линия данных (название)-->
                <div class="drop-orders-data-line">
                    <div class="drop-order-data-label">Название:</div>
                    <div class="drop-order-data-value">{{ order.product_name }}</div>
                </div>

                <!-- Линия данных (размер и количество)-->
                <div class="drop-orders-data-line">
                    <div class="drop-order-data-label">Размер и кол-во:</div>
                    <div class="drop-order-data-value">{{ order.size }} x {{ order.quantity }}</div>
                </div>

                <!-- Линия данных (номер заказа)-->
                <div class="drop-orders-data-line">
                    <div class="drop-order-data-label">Номер заказа:</div>
                    <div class="drop-order-data-value">{{ order.order_id }}</div>
                </div>

                <!-- Линия данных (трек-номер)-->
                <div class="drop-orders-data-line" v-if="!(order.status == 'waiting_confirmation' || order.status == 'in_rf' || order.status == 'transit_to_rf' || order.status == 'in_china' || order.status == 'ordered' || order.status == 'waiting_order')">
                    <div class="drop-order-data-label">Трек-номер:</div>
                    <div class="drop-order-data-value">{{ order.order_number }}</div>
                </div>

                <!-- Линия данных (Служба доставки)-->
                <div class="drop-orders-data-line" v-if="!(order.status == 'waiting_confirmation' || order.status == 'in_rf' || order.status == 'transit_to_rf' || order.status == 'in_china' || order.status == 'ordered' || order.status == 'waiting_order')">
                    <div class="drop-order-data-label">Служба доставки:</div>
                    <div class="drop-order-data-value">{{ order.delivery_service }}</div>
                </div>

                <!-- Линия данных (Оплачено ли)-->
                <div class="drop-orders-data-line">
                    <div class="drop-order-data-label">Оплата внесена:</div>
                    <div class="drop-order-data-value">
                        <span :class="{ 'payment-paid': order.is_payment, 'payment-not-paid': !order.is_payment }">
                            {{ order.is_payment ? 'Да' : 'Нет' }}
                        </span>
                    </div>
                </div>

                <!-- Линия данных (Статус заказа)-->
                <div class="drop-orders-data-line">
                    <div class="drop-order-data-label">Статус:</div>
                    <div class="drop-order-data-value">{{ getStatusText(order.status) }}</div>
                </div>

                <!-- Линия данных (Дата и время заказа)-->
                <div class="drop-orders-data-line">
                    <div class="drop-order-data-label">Дата заказа:</div>
                    <div class="drop-order-data-value">{{ formatDate(order.created_at) }}</div>
                </div>
            </div>

            <!-- Блок кнопок для дропа-->

            <div class="buttons-block" v-if="$route.name === 'DropProfile'">

                <!-- Переход к заполнению данных о доставке товара из-за границы клиенту -->
                <div 
                    class="accept-order" 
                    v-if="order.status === 'in_rf'"
                    @click="handleFillData(order)"
                >
                    Заполнить
                </div>

                <div 
                    class="return-order" 
                    v-if="order.status === 'in_transit'"
                    @click="handleReturn($event, order)"
                    :disabled="loadingActions[order.id] === 'return'"
                >
                    {{ loadingActions[order.id] === 'return' ? 'Обработка...' : 'Возврат' }}
                </div>
                <div 
                    class="canseled-order" 
                    v-if="order.status === 'waiting_shipment' || order.status === 'waiting_confirmation' || order.status == 'in_china' || order.status == 'ordered' || order.status == 'waiting_order'"
                    @click="handleCancel($event, order)"
                    :disabled="loadingActions[order.id] === 'cancel'"
                >
                    {{ loadingActions[order.id] === 'cancel' ? 'Обработка...' : 'Отменить' }}
                </div>
            </div>

            <template v-else-if="$route.name === 'DropManager' || $route.name === 'DropProfileSettingsPage'">
                <div
                    class="size-change-floating"
                    v-if="canChangeSize(order)"
                    @click="handleSizeChange($event, order)"
                    :disabled="loadingActions[order.order_id] === 'change_size'"
                    title="Изменить размер"
                >
                    {{ loadingActions[order.order_id] === 'change_size' ? '...' : '📏' }}
                </div>

                <!-- Блок кнопок для администраторов -->
                <div class="buttons-block">

                <!-- Кнопка смены статуса на "Заказан" -->
                <div class="accept-order"
                    v-if="order.status === 'waiting_order'"
                    @click="handleConfirmAbroad($event, order)"
                    :disabled="loadingActions[order.id] === 'order'"
                >
                    {{ loadingActions[order.id] === 'order' ? 'Обработка...' : 'Заказан' }}
                </div>

                <!-- НОВАЯ КНОПКА: Прибыл в Китай -->
                <div class="accept-order"
                    v-if="order.status === 'ordered'"
                    @click="handleArrivedInChina($event, order)"
                    :disabled="loadingActions[order.id] === 'in_china'"
                >
                    {{ loadingActions[order.id] === 'in_china' ? 'Обработка...' : 'Прибыл в Китай' }}
                </div>

                <!-- НОВАЯ КНОПКА: Отправлено в РФ -->
                <div class="accept-order"
                    v-if="order.status === 'in_china'"
                    @click="handleSendToRussia($event, order)"
                    :disabled="loadingActions[order.id] === 'transit_to_rf'"
                >
                    {{ loadingActions[order.id] === 'transit_to_rf' ? 'Обработка...' : 'Отправлено в РФ' }}
                </div>

                <!-- НОВАЯ КНОПКА: Прибыл в РФ -->
                <div class="accept-order"
                    v-if="order.status === 'transit_to_rf'"
                    @click="handleArrivedInRussia($event, order)"
                    :disabled="loadingActions[order.id] === 'in_rf'"
                >
                    {{ loadingActions[order.id] === 'in_rf' ? 'Обработка...' : 'Прибыл в РФ' }}
                </div>

                <!-- Кнопка возврата заказа (ТОЛЬКО ДЛЯ ЗАКАЗОВ С АВИТО) -->
                <div class="return-order"
                    v-if="order.status === 'in_transit' && order.order_type === 'avito'"
                    @click="handleAdminReturn($event, order)"
                    :disabled="loadingActions[order.id] === 'return'"
                >
                    {{ loadingActions[order.id] === 'return' ? 'Обработка...' : 'Возврат' }}
                </div>

                <!-- Кнопка закрытия возврата (менеджер физически получил товар обратно) -->
                <div class="accept-order"
                    v-if="order.status === 'on_return'"
                    @click="handleCloseReturn($event, order)"
                    :disabled="loadingActions[order.id] === 'close_return'"
                >
                    {{ loadingActions[order.id] === 'close_return' ? 'Обработка...' : 'Закрыть возврат' }}
                </div>

                <!-- КНОВЫЙ: Кнопка подтверждения заказа (только для waiting_confirmation) -->
                <div class="accept-order"
                    v-if="order.status === 'waiting_confirmation'"
                    @click="handleConfirm($event, order)"
                    :disabled="loadingActions[order.id] === 'confirm'"
                >
                    {{ loadingActions[order.id] === 'confirm' ? 'Обработка...' : 'Принять заказ' }}
                </div>
                
                <!-- Кнопка отправки заказа (только для waiting_shipment) -->
                <div class="accept-order"
                    v-if="order.status === 'waiting_shipment'"
                    @click="handleShip($event, order)"
                    :disabled="loadingActions[order.id] === 'ship'"
                >
                    {{ loadingActions[order.id] === 'ship' ? 'Обработка...' : 'Заказ отправлен' }}
                </div>

                <div 
                    class="canseled-order" 
                    v-if="order.status === 'waiting_shipment' || order.status === 'waiting_confirmation' || order.status == 'in_china' || order.status == 'ordered' || order.status == 'waiting_order'"
                    @click="handleCancel($event, order)"
                    :disabled="loadingActions[order.id] === 'cancel'"
                >
                    {{ loadingActions[order.id] === 'cancel' ? 'Обработка...' : 'Отменить' }}
                </div>
                </div>
            </template>
        </div>

        <!-- Индикатор загрузки -->
        <div v-if="loading" class="loading-indicator">
            Загрузка...
        </div>

        <!-- Сообщение о конце списка -->
        <div v-if="!hasMore && orders.length > 0" class="end-of-list">
            {{ admin_orders ? 'Все заказы загружены' : 'Ваши заказы загружены' }}
        </div>

        <!-- Сообщение если нет заказов -->
        <div v-if="!loading && orders.length === 0" class="no-orders">
            {{ admin_orders ? 'Заказы не найдены' : 'У вас пока нет заказов' }}
        </div>

        <div v-if="sizeModalVisible" class="size-modal-overlay" @click.self="closeSizeModal">
            <div class="size-modal-card">
                <div class="size-modal-header">
                    <div class="size-modal-title">Изменить размер</div>
                    <button class="size-modal-close" @click="closeSizeModal" :disabled="sizeModalSubmitting">✕</button>
                </div>

                <div class="size-modal-order">
                    <div>Заказ: <strong>№{{ sizeModalOrder && sizeModalOrder.order_id }}</strong></div>
                    <div>Текущий размер: <strong>{{ sizeModalCurrentSize }}</strong></div>
                    <div>Количество: <strong>{{ sizeModalQuantity }} шт.</strong></div>
                </div>

                <div class="size-modal-options">
                    <button
                        v-for="option in sizeModalAvailableSizes"
                        :key="option.size_name"
                        class="size-option-btn"
                        :class="{ 'size-option-selected': sizeModalSelectedSize === option.size_name }"
                        @click="sizeModalSelectedSize = option.size_name"
                        :disabled="sizeModalSubmitting"
                    >
                        <span>{{ option.size_name }}</span>
                        <span>{{ option.quantity }} шт.</span>
                    </button>
                </div>

                <div class="size-modal-actions">
                    <button class="size-modal-cancel" @click="closeSizeModal" :disabled="sizeModalSubmitting">
                        Отмена
                    </button>
                    <button
                        class="size-modal-confirm"
                        @click="confirmSizeChange"
                        :disabled="!sizeModalSelectedSize || sizeModalSubmitting"
                    >
                        {{ sizeModalSubmitting ? 'Сохранение...' : 'Подтвердить' }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api/api';

export default {
    name: 'DropOrdersList',
    props: {
        filters: {
            type: Object,
            default: () => ({})
        },
        admin_orders: {
            type: Boolean,
            default: false
        },
        drop_user_id: {
            type: [Number, String],
            default: null
        },
    },
    data() {
        return {
            orders: [],
            loading: false,
            hasMore: true,
            currentPage: 1,
            pageSize: 20,
            observer: null,
            loadingActions: {}, // Для отслеживания состояния загрузки по каждому заказу
            sizeModalVisible: false,
            sizeModalOrder: null,
            sizeModalAvailableSizes: [],
            sizeModalCurrentSize: '',
            sizeModalQuantity: 0,
            sizeModalSelectedSize: '',
            sizeModalSubmitting: false
        };
    },

    computed: {
        profileId() {
            return localStorage.getItem('tg_id');
        },
        managerTgId() {
            const tgId = localStorage.getItem('tg_id');
            return tgId ? Number(tgId) : null;
        },
        
        // ВЫЧИСЛЯЕМ, нужно ли ждать drop_user_id
        shouldWaitForDropId() {
            // Определяем, на какой странице мы находимся
            const routeName = this.$route.name;
            
            // Ждем drop_user_id ТОЛЬКО на странице DropProfileSettingsPage
            if (routeName === 'DropProfileSettingsPage') {
                console.log('🔄 На странице DropProfileSettingsPage - ждем drop_user_id');
                return true;
            }
            
            // На других страницах не ждем
            return false;
        }
    },

    watch: {
        filters: {
            handler() {
                this.resetAndLoad();
            },
            deep: true
        },
        admin_orders: {
            handler() {
                this.resetAndLoad();
            }
        },
        drop_user_id: {
            immediate: true,
            handler(newDropUserId) {
                console.log('drop_user_id изменился:', newDropUserId);
                // Всегда перезагружаем при изменении drop_user_id
                this.resetAndLoad();
            }
        },
    },

    mounted() {
        this.loadOrders();
        this.setupIntersectionObserver();
    },

    beforeUnmount() {
        if (this.observer) {
            this.observer.disconnect();
        }
    },

    methods: {
        canChangeSize(order) {
            return ['waiting_confirmation', 'waiting_shipment'].includes(order.status);
        },

        async getAvailableSizes(order) {
            const response = await api.get(`/manager/orders/${order.order_id}/available-sizes`, {
                params: {
                    manager_tg_id: this.managerTgId
                }
            });

            return response.data;
        },

        openSizeModal(order, availableData) {
            this.sizeModalOrder = order;
            this.sizeModalAvailableSizes = availableData.available_sizes || [];
            this.sizeModalCurrentSize = availableData.current_size || '';
            this.sizeModalQuantity = availableData.quantity || 0;
            this.sizeModalSelectedSize = this.sizeModalAvailableSizes.length
                ? this.sizeModalAvailableSizes[0].size_name
                : '';
            this.sizeModalVisible = true;
        },

        resetSizeModalState() {
            this.sizeModalVisible = false;
            this.sizeModalOrder = null;
            this.sizeModalAvailableSizes = [];
            this.sizeModalCurrentSize = '';
            this.sizeModalQuantity = 0;
            this.sizeModalSelectedSize = '';
            this.sizeModalSubmitting = false;
        },

        closeSizeModal() {
            if (this.sizeModalSubmitting) {
                return;
            }
            this.resetSizeModalState();
        },

        async handleSizeChange(event, order) {
            if (event) {
                event.preventDefault();
                event.stopPropagation();
            }

            if (this.loadingActions[order.order_id]) {
                return;
            }

            if (!this.managerTgId) {
                this.showNotification('error', 'Ошибка', 'Не найден Telegram ID менеджера');
                return;
            }

            try {
                this.loadingActions = {
                    ...this.loadingActions,
                    [order.order_id]: 'change_size'
                };

                const availableData = await this.getAvailableSizes(order);
                if (!availableData.available_sizes || availableData.available_sizes.length === 0) {
                    this.showNotification('warning', 'Нет размеров', 'Нет доступных размеров для замены');
                    return;
                }
                this.openSizeModal(order, availableData);
            } catch (error) {
                const errorMessage = error.response?.data?.detail || error.message || 'Не удалось изменить размер';
                this.showNotification('error', 'Ошибка', errorMessage);
            } finally {
                this.loadingActions = {
                    ...this.loadingActions,
                    [order.order_id]: false
                };
            }
        },

        async confirmSizeChange() {
            if (!this.sizeModalOrder || !this.sizeModalSelectedSize) {
                return;
            }

            if (!this.managerTgId) {
                this.showNotification('error', 'Ошибка', 'Не найден Telegram ID менеджера');
                return;
            }

            try {
                this.sizeModalSubmitting = true;

                const response = await api.post(`/manager/orders/${this.sizeModalOrder.order_id}/change-size`, {
                    new_size: this.sizeModalSelectedSize,
                    manager_tg_id: this.managerTgId
                });

                if (!response.data.success) {
                    throw new Error(response.data.message || 'Не удалось изменить размер');
                }

                this.sizeModalOrder.size = response.data.new_size;

                let successMessage = response.data.message;
                if (response.data.is_drop && response.data.notification_sent) {
                    successMessage += ' Уведомление дроп-пользователю отправлено.';
                }

                this.showNotification('success', 'Размер изменен', successMessage);
                this.$emit('order-updated', this.sizeModalOrder);
                this.resetSizeModalState();
            } catch (error) {
                const errorMessage = error.response?.data?.detail || error.message || 'Не удалось изменить размер';
                this.showNotification('error', 'Ошибка', errorMessage);
            } finally {
                this.sizeModalSubmitting = false;
            }
        },

        // Форматирование даты и времение 
        formatDate(created_at) {
            if (!created_at) return '';
            
            const date = new Date(created_at);
            
            // Проверка на валидность даты
            if (isNaN(date.getTime())) return '';
            
            const hours = date.getHours().toString().padStart(2, '0');
            const minutes = date.getMinutes().toString().padStart(2, '0');
            const day = date.getDate().toString().padStart(2, '0');
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const year = date.getFullYear().toString().slice(-2); // последние 2 цифры года
            
            return `${hours}:${minutes} ${day}.${month}.${year}`;
        },

        // === НОВЫЙ МЕТОД: Подтверждение заказа для пре-ордер товаров (из-за рубежа) ===
        // Переводит заказ из waiting_order в ordered
        async handleConfirmAbroad(event, order) {
            if (event) {
                event.preventDefault();
                event.stopPropagation();
            }

            if (this.loadingActions[order.order_id]) {
                console.log('Заказ уже обрабатывается:', order.order_id);
                return;
            }
            
            console.log('🚀 Начало подтверждения заказа для пре-ордер товара:', order.order_id);
            console.log('📦 Информация о заказе:', {
                order_id: order.order_id,
                product_name: order.product_name,
                size: order.size,
                quantity: order.quantity,
                status: order.status
            });
            
            try {
                // Устанавливаем состояние загрузки для этого заказа
                this.loadingActions = {
                    ...this.loadingActions,
                    [order.order_id]: 'order'  // Используем ключ 'order' для этого действия
                };
                
                // Подтверждаем действие
                const confirmed = confirm(`Подтвердить заказ №${order.order_id} как "Заказан"?\n\n` +
                    `Товар: ${order.product_name}\n` +
                    `Размер: ${order.size} x ${order.quantity} шт.\n\n` +
                    `Это пре-ордер товар (из-за рубежа). После подтверждения:\n` +
                    `• Статус изменится на "Заказан"\n` +
                    `• Товар будет заказан в Китае\n` +
                    `• Пользователь получит уведомление`);
                
                if (!confirmed) {
                    console.log('❌ Пользователь отменил подтверждение заказа');
                    this.loadingActions = {
                        ...this.loadingActions,
                        [order.order_id]: false
                    };
                    return;
                }

                console.log('📤 Отправка запроса на подтверждение пре-ордер заказа:', order.order_id);
                
                // Отправляем POST запрос на эндпоинт /manager/orders/{order_id}/order
                const response = await api.post(`/manager/orders/${order.order_id}/order`);
                
                console.log('📥 Ответ от сервера:', response.data);

                if (response.data.success) {
                    // Обновляем статус заказа локально
                    const oldStatus = order.status;
                    order.status = response.data.new_status || 'ordered';
                    
                    // Показываем уведомление об успехе
                    let successMessage = response.data.message || `Заказ №${order.order_id} успешно переведен в статус "Заказан"`;
                    
                    // Добавляем дополнительную информацию из ответа
                    if (response.data.is_pre_order) {
                        successMessage += `\n\n📦 Пре-ордер товар заказан в Китае.`;
                    }
                    
                    // Добавляем информацию об уведомлении если это дроп-заказ
                    if (response.data.is_drop) {
                        if (response.data.notification_sent) {
                            const username = response.data.drop_username || 'пользователь';
                            successMessage += `\n✅ Уведомление отправлено ${username}.`;
                        } else if (response.data.notification_error) {
                            successMessage += `\n⚠️ Не удалось отправить уведомление: ${response.data.notification_error}`;
                        }
                    }
                    
                    this.showNotification('success', 'Заказ подтвержден', successMessage);
                    
                    // Эмитим событие для обновления родительского компонента
                    this.$emit('order-updated', order);
                    
                    console.log('✅ Заказ успешно подтвержден:', {
                        order_id: order.order_id,
                        old_status: oldStatus,
                        new_status: order.status,
                        response: response.data
                    });
                } else {
                    throw new Error(response.data.message || 'Неизвестная ошибка при подтверждении заказа');
                }
            } catch (error) {
                console.error('❌ Ошибка при подтверждении пре-ордер заказа:', error);
                
                // Извлекаем сообщение об ошибке
                let errorMessage = 'Не удалось подтвердить заказ';
                
                if (error.response) {
                    // Сервер вернул ошибку с HTTP статусом
                    console.error('❌ Response error data:', error.response.data);
                    console.error('❌ Response error status:', error.response.status);
                    
                    errorMessage = error.response.data?.detail || 
                                error.response.data?.message || 
                                `Ошибка сервера: ${error.response.status}`;
                } else if (error.request) {
                    // Запрос был отправлен, но ответ не получен
                    console.error('❌ No response received:', error.request);
                    errorMessage = 'Сервер не отвечает. Проверьте подключение к интернету.';
                } else {
                    // Ошибка при настройке запроса
                    errorMessage = error.message || 'Неизвестная ошибка';
                }
                
                // Проверяем специфичные ошибки
                if (errorMessage.includes('waiting_order')) {
                    errorMessage = 'Этот заказ уже не в статусе "Ожидает заказа". Возможно, он уже был обработан.';
                } else if (errorMessage.includes('pre-order') || errorMessage.includes('пре-ордер')) {
                    errorMessage = 'Эта операция доступна только для пре-ордер товаров (из-за рубежа).';
                } else if (errorMessage.includes('not found')) {
                    errorMessage = 'Заказ не найден. Возможно, он был удален.';
                }
                
                this.showNotification('error', 'Ошибка', errorMessage);
            } finally {
                // Сбрасываем состояние загрузки
                this.loadingActions = {
                    ...this.loadingActions,
                    [order.order_id]: false
                };
                console.log('🏁 Завершение обработки подтверждения заказа:', order.order_id);
            }
        },

        // === НОВЫЙ МЕТОД: Отметить заказ как "Прибыл в Китай" ===
        // Переводит заказ из ordered в in_china
        async handleArrivedInChina(event, order) {
            if (event) {
                event.preventDefault();
                event.stopPropagation();
            }

            if (this.loadingActions[order.order_id]) {
                console.log('Заказ уже обрабатывается:', order.order_id);
                return;
            }
            
            console.log('🚀 Начало обработки заказа как "Прибыл в Китай":', order.order_id);
            console.log('📦 Информация о заказе:', {
                order_id: order.order_id,
                product_name: order.product_name,
                size: order.size,
                quantity: order.quantity,
                status: order.status
            });
            
            try {
                // Устанавливаем состояние загрузки для этого заказа
                this.loadingActions = {
                    ...this.loadingActions,
                    [order.order_id]: 'in_china'
                };
                
                // Подтверждаем действие
                const confirmed = confirm(`Подтвердить прибытие заказа №${order.order_id} в Китай?\n\n` +
                    `Товар: ${order.product_name}\n` +
                    `Размер: ${order.size} x ${order.quantity} шт.\n\n` +
                    `После подтверждения:\n` +
                    `• Статус изменится на "Прибыл в Китай"\n` +
                    `• Пользователь получит уведомление о доступности видео-обзора`);
                
                if (!confirmed) {
                    console.log('❌ Пользователь отменил подтверждение прибытия');
                    this.loadingActions = {
                        ...this.loadingActions,
                        [order.order_id]: false
                    };
                    return;
                }

                console.log('📤 Отправка запроса на отметку "Прибыл в Китай":', order.order_id);
                
                // Отправляем POST запрос на эндпоинт /manager/orders/{order_id}/arrived-china
                const response = await api.post(`/manager/orders/${order.order_id}/arrived-china`);
                
                console.log('📥 Ответ от сервера:', response.data);

                if (response.data.success) {
                    // Обновляем статус заказа локально
                    const oldStatus = order.status;
                    order.status = response.data.new_status || 'in_china';
                    
                    // Показываем уведомление об успехе
                    let successMessage = response.data.message || `Заказ №${order.order_id} отмечен как "Прибыл в Китай"`;
                    
                    // Добавляем информацию об уведомлении если это дроп-заказ
                    if (response.data.is_drop) {
                        if (response.data.notification_sent) {
                            const username = response.data.drop_username || 'пользователь';
                            successMessage += `\n✅ Уведомление о видео-обзоре отправлено ${username}.`;
                            
                            // Добавляем информацию о видео если есть
                            if (response.data.video_url) {
                                successMessage += `\n📹 Ссылка на видео: ${response.data.video_url}`;
                            }
                        } else if (response.data.notification_error) {
                            successMessage += `\n⚠️ Не удалось отправить уведомление: ${response.data.notification_error}`;
                        }
                    }
                    
                    this.showNotification('success', 'Статус обновлен', successMessage);
                    
                    // Эмитим событие для обновления родительского компонента
                    this.$emit('order-updated', order);
                    
                    console.log('✅ Заказ успешно отмечен как "Прибыл в Китай":', {
                        order_id: order.order_id,
                        old_status: oldStatus,
                        new_status: order.status,
                        response: response.data
                    });
                } else {
                    throw new Error(response.data.message || 'Неизвестная ошибка при обновлении статуса');
                }
            } catch (error) {
                console.error('❌ Ошибка при отметке "Прибыл в Китай":', error);
                
                // Извлекаем сообщение об ошибке
                let errorMessage = 'Не удалось обновить статус заказа';
                
                if (error.response) {
                    // Сервер вернул ошибку с HTTP статусом
                    console.error('❌ Response error data:', error.response.data);
                    console.error('❌ Response error status:', error.response.status);
                    
                    errorMessage = error.response.data?.detail || 
                                error.response.data?.message || 
                                `Ошибка сервера: ${error.response.status}`;
                } else if (error.request) {
                    // Запрос был отправлен, но ответ не получен
                    console.error('❌ No response received:', error.request);
                    errorMessage = 'Сервер не отвечает. Проверьте подключение к интернету.';
                } else {
                    // Ошибка при настройке запроса
                    errorMessage = error.message || 'Неизвестная ошибка';
                }
                
                // Проверяем специфичные ошибки
                if (errorMessage.includes('ordered')) {
                    errorMessage = 'Этот заказ должен быть в статусе "Заказан". Текущий статус не позволяет выполнить операцию.';
                } else if (errorMessage.includes('not found')) {
                    errorMessage = 'Заказ не найден. Возможно, он был удален.';
                }
                
                this.showNotification('error', 'Ошибка', errorMessage);
            } finally {
                // Сбрасываем состояние загрузки
                this.loadingActions = {
                    ...this.loadingActions,
                    [order.order_id]: false
                };
                console.log('🏁 Завершение обработки заказа:', order.order_id);
            }
        },

        // === НОВЫЙ МЕТОД: Отправить заказ в РФ ===
        // Переводит заказ из in_china в transit_to_rf
        async handleSendToRussia(event, order) {
            if (event) {
                event.preventDefault();
                event.stopPropagation();
            }

            if (this.loadingActions[order.order_id]) {
                console.log('Заказ уже обрабатывается:', order.order_id);
                return;
            }
            
            console.log('🚀 Начало отправки заказа в РФ:', order.order_id);
            console.log('📦 Информация о заказе:', {
                order_id: order.order_id,
                product_name: order.product_name,
                size: order.size,
                quantity: order.quantity,
                status: order.status
            });
            
            try {
                // Устанавливаем состояние загрузки для этого заказа
                this.loadingActions = {
                    ...this.loadingActions,
                    [order.order_id]: 'transit_to_rf'
                };
                
                // Подтверждаем действие
                const confirmed = confirm(`Подтвердить отправку заказа №${order.order_id} в РФ?\n\n` +
                    `Товар: ${order.product_name}\n` +
                    `Размер: ${order.size} x ${order.quantity} шт.\n\n` +
                    `После подтверждения:\n` +
                    `• Статус изменится на "Отправлено в РФ"\n` +
                    `• Пользователь получит уведомление о том, что товар в пути в Россию`);
                
                if (!confirmed) {
                    console.log('❌ Пользователь отменил отправку в РФ');
                    this.loadingActions = {
                        ...this.loadingActions,
                        [order.order_id]: false
                    };
                    return;
                }

                console.log('📤 Отправка запроса на отправку в РФ:', order.order_id);
                
                // Отправляем POST запрос на эндпоинт /manager/orders/{order_id}/send-to-russia
                const response = await api.post(`/manager/orders/${order.order_id}/send-to-russia`);
                
                console.log('📥 Ответ от сервера:', response.data);

                if (response.data.success) {
                    // Обновляем статус заказа локально
                    const oldStatus = order.status;
                    order.status = response.data.new_status || 'transit_to_rf';
                    
                    // Показываем уведомление об успехе
                    let successMessage = response.data.message || `Заказ №${order.order_id} отправлен в РФ`;
                    
                    // Добавляем информацию об уведомлении если это дроп-заказ
                    if (response.data.is_drop) {
                        if (response.data.notification_sent) {
                            const username = response.data.drop_username || 'пользователь';
                            successMessage += `\n✅ Уведомление отправлено ${username}.`;
                        } else if (response.data.notification_error) {
                            successMessage += `\n⚠️ Не удалось отправить уведомление: ${response.data.notification_error}`;
                        }
                    }
                    
                    this.showNotification('success', 'Статус обновлен', successMessage);
                    
                    // Эмитим событие для обновления родительского компонента
                    this.$emit('order-updated', order);
                    
                    console.log('✅ Заказ успешно отправлен в РФ:', {
                        order_id: order.order_id,
                        old_status: oldStatus,
                        new_status: order.status,
                        response: response.data
                    });
                } else {
                    throw new Error(response.data.message || 'Неизвестная ошибка при отправке в РФ');
                }
            } catch (error) {
                console.error('❌ Ошибка при отправке заказа в РФ:', error);
                
                // Извлекаем сообщение об ошибке
                let errorMessage = 'Не удалось отправить заказ в РФ';
                
                if (error.response) {
                    console.error('❌ Response error data:', error.response.data);
                    errorMessage = error.response.data?.detail || 
                                error.response.data?.message || 
                                `Ошибка сервера: ${error.response.status}`;
                } else if (error.request) {
                    errorMessage = 'Сервер не отвечает. Проверьте подключение к интернету.';
                } else {
                    errorMessage = error.message || 'Неизвестная ошибка';
                }
                
                // Проверяем специфичные ошибки
                if (errorMessage.includes('in_china')) {
                    errorMessage = 'Этот заказ должен быть в статусе "Прибыл в Китай". Текущий статус не позволяет выполнить операцию.';
                } else if (errorMessage.includes('not found')) {
                    errorMessage = 'Заказ не найден. Возможно, он был удален.';
                }
                
                this.showNotification('error', 'Ошибка', errorMessage);
            } finally {
                // Сбрасываем состояние загрузки
                this.loadingActions = {
                    ...this.loadingActions,
                    [order.order_id]: false
                };
                console.log('🏁 Завершение обработки заказа:', order.order_id);
            }
        },

        // === НОВЫЙ МЕТОД: Прибыл в РФ ===
        // Переводит заказ из transit_to_rf в in_rf
        async handleArrivedInRussia(event, order) {
            if (event) {
                event.preventDefault();
                event.stopPropagation();
            }

            if (this.loadingActions[order.order_id]) {
                console.log('Заказ уже обрабатывается:', order.order_id);
                return;
            }
            
            console.log('🚀 Начало обработки заказа как "Прибыл в РФ":', order.order_id);
            console.log('📦 Информация о заказе:', {
                order_id: order.order_id,
                product_name: order.product_name,
                size: order.size,
                quantity: order.quantity,
                status: order.status
            });
            
            try {
                // Устанавливаем состояние загрузки для этого заказа
                this.loadingActions = {
                    ...this.loadingActions,
                    [order.order_id]: 'in_rf'
                };
                
                // Подтверждаем действие
                const confirmed = confirm(`Подтвердить прибытие заказа №${order.order_id} в РФ?\n\n` +
                    `Товар: ${order.product_name}\n` +
                    `Размер: ${order.size} x ${order.quantity} шт.\n\n` +
                    `После подтверждения:\n` +
                    `• Статус изменится на "Прибыл в РФ"\n` +
                    `• Пользователь получит уведомление о том, что товар в России\n` +
                    `• Заказ будет готов к выдаче или отправке по России`);
                
                if (!confirmed) {
                    console.log('❌ Пользователь отменил подтверждение прибытия в РФ');
                    this.loadingActions = {
                        ...this.loadingActions,
                        [order.order_id]: false
                    };
                    return;
                }

                console.log('📤 Отправка запроса на отметку "Прибыл в РФ":', order.order_id);
                
                // Отправляем POST запрос на эндпоинт /manager/orders/{order_id}/arrived-russia
                const response = await api.post(`/manager/orders/${order.order_id}/arrived-russia`);
                
                console.log('📥 Ответ от сервера:', response.data);

                if (response.data.success) {
                    // Обновляем статус заказа локально
                    const oldStatus = order.status;
                    order.status = response.data.new_status || 'in_rf';
                    
                    // Показываем уведомление об успехе
                    let successMessage = response.data.message || `Заказ №${order.order_id} отмечен как "Прибыл в РФ"`;
                    
                    // Добавляем информацию об уведомлении если это дроп-заказ
                    if (response.data.is_drop) {
                        if (response.data.notification_sent) {
                            const username = response.data.drop_username || 'пользователь';
                            successMessage += `\n✅ Уведомление о прибытии в РФ отправлено ${username}.`;
                        } else if (response.data.notification_error) {
                            successMessage += `\n⚠️ Не удалось отправить уведомление: ${response.data.notification_error}`;
                        }
                    }
                    
                    this.showNotification('success', 'Статус обновлен', successMessage);
                    
                    // Эмитим событие для обновления родительского компонента
                    this.$emit('order-updated', order);
                    
                    console.log('✅ Заказ успешно отмечен как "Прибыл в РФ":', {
                        order_id: order.order_id,
                        old_status: oldStatus,
                        new_status: order.status,
                        response: response.data
                    });
                } else {
                    throw new Error(response.data.message || 'Неизвестная ошибка при обновлении статуса');
                }
            } catch (error) {
                console.error('❌ Ошибка при отметке "Прибыл в РФ":', error);
                
                // Извлекаем сообщение об ошибке
                let errorMessage = 'Не удалось обновить статус заказа';
                
                if (error.response) {
                    // Сервер вернул ошибку с HTTP статусом
                    console.error('❌ Response error data:', error.response.data);
                    console.error('❌ Response error status:', error.response.status);
                    
                    errorMessage = error.response.data?.detail || 
                                error.response.data?.message || 
                                `Ошибка сервера: ${error.response.status}`;
                } else if (error.request) {
                    // Запрос был отправлен, но ответ не получен
                    console.error('❌ No response received:', error.request);
                    errorMessage = 'Сервер не отвечает. Проверьте подключение к интернету.';
                } else {
                    // Ошибка при настройке запроса
                    errorMessage = error.message || 'Неизвестная ошибка';
                }
                
                // Проверяем специфичные ошибки
                if (errorMessage.includes('transit_to_rf')) {
                    errorMessage = 'Этот заказ должен быть в статусе "Отправлено в РФ". Текущий статус не позволяет выполнить операцию.';
                } else if (errorMessage.includes('not found')) {
                    errorMessage = 'Заказ не найден. Возможно, он был удален.';
                }
                
                this.showNotification('error', 'Ошибка', errorMessage);
            } finally {
                // Сбрасываем состояние загрузки
                this.loadingActions = {
                    ...this.loadingActions,
                    [order.order_id]: false
                };
                console.log('🏁 Завершение обработки заказа:', order.order_id);
            }
        },

        // В разделе methods добавляем новый метод:

        // === НОВЫЙ МЕТОД: Переход на страницу заполнения данных для отправки ===
        handleFillData(order) {
            console.log('📝 Переход на страницу заполнения данных для заказа:', order.order_id);
            
            // Сохраняем ID заказа в localStorage или sessionStorage для использования на странице заполнения
            try {
                // Можно сохранить в sessionStorage (очистится при закрытии вкладки)
                sessionStorage.setItem('current_pre_order_id', order.order_id);
                sessionStorage.setItem('current_pre_order_product', JSON.stringify({
                    id: order.id,
                    order_id: order.order_id,
                    product_name: order.product_name,
                    size: order.size,
                    quantity: order.quantity
                }));
                
                console.log('✅ Данные заказа сохранены в sessionStorage');
            } catch (e) {
                console.error('❌ Ошибка при сохранении данных в sessionStorage:', e);
            }
            
            // Переходим на страницу заполнения данных
            // Предполагаем, что у вас есть с именем 'FromAbroadOrder'
            this.$router.push({ 
                name: 'FromAbroadOrder',
                params: { 
                    orderId: order.order_id 
                }
            });
        },

        // === НОВЫЙ МЕТОД: Подтверждение заказа (из waiting_confirmation в waiting_shipment) ===
        async handleConfirm(event, order) {
            if (event) {
                event.preventDefault();
                event.stopPropagation();
            }

            if (this.loadingActions[order.order_id]) {
                console.log('Заказ уже обрабатывается:', order.order_id);
                return;
            }
            
            console.log('Начало подтверждения заказа:', order.order_id);
            
            try {
                this.loadingActions = {
                    ...this.loadingActions,
                    [order.order_id]: 'confirm'
                };
                
                // Подтверждаем действие
                const confirmed = confirm(`Подтвердить заказ №${order.order_id}?\nТовар: ${order.product_name}\nРазмер: ${order.size} x ${order.quantity}`);
                
                if (!confirmed) {
                    this.loadingActions = {
                        ...this.loadingActions,
                        [order.order_id]: false
                    };
                    console.log('Пользователь отменил подтверждение заказа');
                    return;
                }

                console.log('Отправка запроса на подтверждение заказа:', order.order_id);
                
                // Используем order.order_id вместо order.id
                const response = await api.post(`/manager/orders/${order.order_id}/confirm`);
                
                console.log('Ответ от сервера (подтверждение):', response.data);

                if (response.data.success) {
                    // Обновляем статус заказа локально
                    order.status = 'waiting_shipment';
                    
                    // Показываем уведомление об успехе
                    let successMessage = response.data.message;
                    
                    // Добавляем информацию о списании со склада
                    if (response.data.stock_updated) {
                        successMessage += ` Товар "${response.data.product_name}" (${response.data.size}) x ${response.data.stock_deducted} шт. списан со склада.`;
                    }
                    
                    // Добавляем информацию об уведомлении если это дроп-заказ
                    if (response.data.is_drop && response.data.notification_sent) {
                        const username = response.data.drop_username || 'пользователь';
                        successMessage += ` Уведомление отправлено ${username}.`;
                    }
                    
                    this.showNotification('success', 'Заказ подтвержден', successMessage);
                    
                    // Эмитим событие для обновления родительского компонента
                    this.$emit('order-updated', order);
                    
                    console.log('Заказ успешно подтвержден:', order.order_id);
                } else {
                    throw new Error(response.data.message || 'Неизвестная ошибка');
                }
            } catch (error) {
                console.error('Ошибка при подтверждении заказа:', error);
                const errorMessage = error.response?.data?.detail || error.message || 'Не удалось подтвердить заказ';
                this.showNotification('error', 'Ошибка', errorMessage);
            } finally {
                // Сбрасываем состояние загрузки
                this.loadingActions = {
                    ...this.loadingActions,
                    [order.order_id]: false
                };
                console.log('Завершение обработки подтверждения заказа:', order.order_id);
            }
        },

        // === Метод отмены заказа (обновлен для админов) ===
        async handleCancel(event, order) {
            // Предотвращаем всплытие события
            if (event) {
                event.preventDefault();
                event.stopPropagation();
            }

            if (this.loadingActions[order.order_id]) {
                console.log('Заказ уже обрабатывается:', order.order_id);
                return;
            }
            
            console.log('Начало отмены заказа:', order.order_id);
            
            try {
                // Устанавливаем состояние загрузки для этого заказа
                this.loadingActions = {
                    ...this.loadingActions,
                    [order.order_id]: 'cancel'
                };
                
                // Спрашиваем причину отмены (необязательно)
                const reason = prompt('Укажите причину отмены (необязательно):');
                if (reason === null) {
                    // Пользователь отменил ввод
                    console.log('Пользователь отменил ввод причины');
                    this.loadingActions = {
                        ...this.loadingActions,
                        [order.order_id]: false
                    };
                    return;
                }

                console.log('Отправка запроса на отмену заказа:', order.order_id);
                
                // РАЗДЕЛЕНИЕ: для админов используем новый endpoint с параметром в пути
                if (this.admin_orders) {
                    // НОВЫЙ endpoint для администраторов - используем order.order_id
                    const data = {
                        reason: reason || ''
                    };
                    
                    console.log('Используем новый endpoint для админов:', data);
                    const response = await api.post(`/manager/orders/${order.order_id}/cancel`, data);
                    
                    console.log('Ответ от сервера (админ):', response.data);
                    
                    if (response.data.success) {
                        // Обновляем статус заказа локально
                        order.status = 'canceled';
                        
                        // Показываем уведомление об успехе
                        let successMessage = response.data.message;
                        
                        // Добавляем информацию о возврате в наличие если есть
                        if (response.data.stock_returned) {
                            successMessage += ` Товар "${response.data.product_name}" (${response.data.size}) x ${response.data.quantity_returned} шт. возвращен в наличие.`;
                        }
                        
                        // Добавляем информацию об уведомлении если это дроп-заказ
                        if (response.data.is_drop && response.data.notification_sent) {
                            const username = response.data.drop_username || 'пользователь';
                            successMessage += ` Уведомление отправлено ${username}.`;
                        }
                        
                        this.showNotification('success', 'Заказ отменен', successMessage);
                        
                        // Эмитим событие для обновления родительского компонента
                        this.$emit('order-updated', order);
                        
                        console.log('Заказ успешно отменен (админ):', order.order_id);
                    } else {
                        throw new Error(response.data.message || 'Неизвестная ошибка');
                    }
                } else {
                    // Старый endpoint для дроп-пользователей
                    const endpoint = '/drop/profile/orders/cancel';
                    
                    const data = {
                        order_id: order.order_id, // Используем order.order_id
                        reason: reason || 'Причина не указана'
                    };
                    
                    // Добавляем profile_id только если не админский режим
                    if (!this.admin_orders) {
                        data.profile_id = parseInt(this.profileId);
                    }

                    const response = await api.post(endpoint, data);

                    console.log('Ответ от сервера (дроп):', response.data);

                    if (response.data.status === 'success') {
                        // Обновляем статус заказа локально
                        order.status = 'canceled';
                        
                        // Показываем уведомление об успехе
                        this.showNotification('success', 'Заказ отменен', response.data.message);
                        
                        // Эмитим событие для обновления родительского компонента
                        this.$emit('order-updated', order);
                        
                        console.log('Заказ успешно отменен (дроп):', order.order_id);
                    } else {
                        throw new Error(response.data.message || 'Неизвестная ошибка');
                    }
                }
            } catch (error) {
                console.error('Ошибка при отмене заказа:', error);
                const errorMessage = error.response?.data?.detail || error.message || 'Не удалось отменить заказ';
                this.showNotification('error', 'Ошибка', errorMessage);
            } finally {
                // Сбрасываем состояние загрузки
                this.loadingActions = {
                    ...this.loadingActions,
                    [order.order_id]: false
                };
                console.log('Завершение обработки отмены заказа:', order.order_id);
            }
        },

        showNotification(type, title, message) {
            try {
                // Используем встроенные уведомления или кастомные
                if (this.$notify) {
                    // Для Element UI
                    this.$notify({
                        title: title,
                        message: message,
                        type: type,
                        duration: 5000
                    });
                } else if (this.$message) {
                    // Для Element UI альтернатива
                    this.$message({
                        message: message,
                        type: type,
                        duration: 5000
                    });
                } else if (this.$toast) {
                    // Для Vue Toastification
                    this.$toast[type](message, { title: title });
                } else {
                    // Нативное уведомление
                    alert(`${title}: ${message}`);
                }
            } catch (notificationError) {
                console.error('Ошибка при показе уведомления:', notificationError);
                // Фолбэк на alert
                alert(`${title}: ${message}`);
            }
        },

        // === Метод отправки заказа (из waiting_shipment в in_transit) ===
        async handleShip(event, order) {
            if (event) {
                event.preventDefault();
                event.stopPropagation();
            }

            if (this.loadingActions[order.order_id]) {
                console.log('Заказ уже обрабатывается:', order.order_id);
                return;
            }
            
            console.log('Отправка заказа:', order.order_id);
            
            // Проверяем, можно ли отправить заказ
            if (!this.canShipOrder(order)) {
                this.showNotification('warning', 'Внимание', 'Заказ нельзя отправить в текущем статусе');
                return;
            }

            await this.confirmShipOrderDirect(order);
        },

        async confirmShipOrderDirect(order) {
            try {
                this.loadingActions = {
                    ...this.loadingActions,
                    [order.order_id]: 'ship'
                };
                
                console.log('Отправка запроса на отправку заказа:', order.order_id);
                
                // Используем order.order_id вместо order.id
                const response = await api.post(`/manager/orders/${order.order_id}/ship`);
                
                console.log('Ответ от сервера:', response.data);

                if (response.data.success) {
                    order.status = 'in_transit';
                    
                    if (response.data.is_drop) {
                        order.notification_sent = response.data.notification_sent;
                        if (response.data.notification_error) {
                            console.warn('Ошибка отправки уведомления:', response.data.notification_error);
                        }
                    }
                    
                    let successMessage = response.data.message;
                    
                    if (response.data.is_drop) {
                        if (response.data.notification_sent) {
                            successMessage += ' Уведомление пользователю отправлено.';
                        } else {
                            successMessage += ' Уведомление пользователю НЕ отправлено (ошибка).';
                        }
                    }
                    
                    this.showNotification('success', 'Заказ отправлен', successMessage);
                    this.$emit('order-updated', order);
                    
                    console.log('Заказ успешно отправлен:', order.order_id);
                } else {
                    throw new Error(response.data.message || 'Неизвестная ошибка');
                }
            } catch (error) {
                console.error('Ошибка при отправке заказа:', error);
                const errorMessage = error.response?.data?.detail || error.message || 'Не удалось отправить заказ';
                this.showNotification('error', 'Ошибка', errorMessage);
            } finally {
                this.loadingActions = {
                    ...this.loadingActions,
                    [order.order_id]: false
                };
                console.log('Завершение обработки отправки заказа:', order.order_id);
            }
        },

        // === Метод возврата для АДМИНИСТРАТОРОВ (только Авито) ===
        async handleAdminReturn(event, order) {
            console.log('Админский возврат заказа:', order.order_id);
            if (event) {
                event.preventDefault();
                event.stopPropagation();
            }

            // Проверяем, что это заказ с Авито
            if (order.order_type !== 'avito') {
                this.showNotification('warning', 'Внимание', 'Возврат через эту кнопку доступен только для заказов с Авито');
                return;
            }

            if (this.loadingActions[order.order_id]) {
                console.log('Заказ уже обрабатывается:', order.order_id);
                return;
            }
            
            console.log('Начало возврата заказа Авито для администратора:', order.order_id);
            
            try {
                this.loadingActions = {
                    ...this.loadingActions,
                    [order.order_id]: 'return'
                };
                
                console.log('Отправка запроса на возврат заказа Авито:', order.order_id);
                
                // Используем order.order_id вместо order.id
                const response = await api.post(`/manager/orders/${order.order_id}/return`);
                
                console.log('Ответ от сервера:', response.data);

                if (response.data.success) {
                    // Обновляем статус заказа локально
                    order.status = 'on_return';
                    
                    // Показываем уведомление об успехе
                    let successMessage = response.data.message;
                    if (response.data.product_name && response.data.size && response.data.quantity_returned) {
                        successMessage += ` Товар "${response.data.product_name}" (${response.data.size}) x ${response.data.quantity_returned} шт. возвращен в наличие.`;
                    }
                    
                    this.showNotification('success', 'Возврат оформлен', successMessage);
                    
                    // Эмитим событие для обновления родительского компонента
                    this.$emit('order-updated', order);
                    
                    console.log('Возврат заказа Авито успешно оформлен:', order.order_id);
                } else {
                    throw new Error(response.data.message || 'Неизвестная ошибка');
                }
            } catch (error) {
                console.error('Ошибка при оформлении возврата заказа Авито:', error);
                const errorMessage = error.response?.data?.detail || error.message || 'Не удалось оформить возврат';
                this.showNotification('error', 'Ошибка', errorMessage);
            } finally {
                // Сбрасываем состояние загрузки
                this.loadingActions = {
                    ...this.loadingActions,
                    [order.order_id]: false
                };
                console.log('Завершение обработки возврата заказа:', order.order_id);
            }
        },

        // === Метод закрытия возврата для АДМИНИСТРАТОРОВ (товар физически получен обратно) ===
        async handleCloseReturn(event, order) {
            if (event) {
                event.preventDefault();
                event.stopPropagation();
            }

            if (this.loadingActions[order.order_id]) {
                console.log('Заказ уже обрабатывается:', order.order_id);
                return;
            }

            console.log('Закрытие возврата заказа:', order.order_id);

            try {
                this.loadingActions = {
                    ...this.loadingActions,
                    [order.order_id]: 'close_return'
                };

                const response = await api.post(`/manager/orders/${order.order_id}/close-return`, null, {
                    params: {
                        manager_tg_id: this.managerTgId
                    }
                });

                if (response.data.success) {
                    order.status = 'return_closed';

                    let successMessage = response.data.message;
                    if (response.data.product_name && response.data.size && response.data.quantity_returned) {
                        successMessage += ` Товар "${response.data.product_name}" (${response.data.size}) x ${response.data.quantity_returned} шт. возвращен в наличие.`;
                    }

                    this.showNotification('success', 'Возврат закрыт', successMessage);
                    this.$emit('order-updated', order);
                } else {
                    throw new Error(response.data.message || 'Неизвестная ошибка');
                }
            } catch (error) {
                console.error('Ошибка при закрытии возврата:', error);
                const errorMessage = error.response?.data?.detail || error.message || 'Не удалось закрыть возврат';
                this.showNotification('error', 'Ошибка', errorMessage);
            } finally {
                this.loadingActions = {
                    ...this.loadingActions,
                    [order.order_id]: false
                };
            }
        },

        canShipOrder(order) {
            // Теперь отправка возможна только из статуса waiting_shipment
            const allowedStatuses = ['waiting_shipment'];
            const allowedTypes = ['drop', 'avito'];
            
            return allowedStatuses.includes(order.status) && 
                   allowedTypes.includes(order.order_type);
        },

        // === Метод возврата для дроп-пользователей ===
        async handleReturn(event, order) {
            // Предотвращаем всплытие события
            if (event) {
                event.preventDefault();
                event.stopPropagation();
            }

            if (this.loadingActions[order.order_id]) {
                console.log('Заказ уже обрабатывается:', order.order_id);
                return;
            }
            
            console.log('Начало возврата заказа:', order.order_id);
            
            try {
                // Устанавливаем состояние загрузки для этого заказа
                this.loadingActions = {
                    ...this.loadingActions,
                    [order.order_id]: 'return'
                };
                
                // Спрашиваем причину возврата (обязательно)
                const reason = prompt('Укажите причину возврата:');
                if (reason === null) {
                    // Пользователь отменил ввод
                    console.log('Пользователь отменил ввод причины возврата');
                    this.loadingActions = {
                        ...this.loadingActions,
                        [order.order_id]: false
                    };
                    return;
                }

                if (!reason.trim()) {
                    this.showNotification('warning', 'Внимание', 'Пожалуйста, укажите причину возврата');
                    this.loadingActions = {
                        ...this.loadingActions,
                        [order.order_id]: false
                    };
                    return;
                }

                console.log('Отправка запроса на возврат заказа:', order.order_id);
                
                // Если это админский режим, используем другой endpoint
                const endpoint = this.admin_orders ? 
                    '/manager/orders/return' : 
                    '/drop/profile/orders/return';
                
                const data = {
                    order_id: order.order_id, // Используем order.order_id
                    reason: reason
                };
                
                // Добавляем profile_id только если не админский режим
                if (!this.admin_orders) {
                    data.profile_id = parseInt(this.profileId);
                }

                const response = await api.post(endpoint, data);

                console.log('Ответ от сервера:', response.data);

                if (response.data.status === 'success') {
                    // Обновляем статус заказа локально
                    order.status = 'on_return';
                    
                    // Показываем уведомление об успехе
                    this.showNotification('success', 'Запрос на возврат отправлен', response.data.message);
                    
                    // Эмитим событие для обновления родительского компонента
                    this.$emit('order-updated', order);
                    
                    console.log('Запрос на возврат успешно отправлен:', order.order_id);
                } else {
                    throw new Error(response.data.message || 'Неизвестная ошибка');
                }
            } catch (error) {
                console.error('Ошибка при оформлении возврата:', error);
                const errorMessage = error.response?.data?.detail || error.message || 'Не удалось оформить возврат';
                this.showNotification('error', 'Ошибка', errorMessage);
            } finally {
                // Сбрасываем состояние загрузки
                this.loadingActions = {
                    ...this.loadingActions,
                    [order.order_id]: false
                };
                console.log('Завершение обработки возврата заказа:', order.order_id);
            }
        },

        setupIntersectionObserver() {
            try {
                this.observer = new IntersectionObserver((entries) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting && !this.loading && this.hasMore) {
                            this.loadOrders();
                        }
                    });
                });

                this.$nextTick(() => {
                    this.observeLastElement();
                });
            } catch (error) {
                console.error('Ошибка при настройке Intersection Observer:', error);
            }
        },

        observeLastElement() {
            try {
                if (this.observer && this.orders.length > 0) {
                    const elements = this.$el.querySelectorAll('.drop-order-block');
                    if (elements.length > 0) {
                        this.observer.observe(elements[elements.length - 1]);
                    }
                }
            } catch (error) {
                console.error('Ошибка при наблюдении за элементами:', error);
            }
        },

        async loadOrders() {
            if (this.loading || !this.hasMore) return;
            
            // ПРОВЕРКА: ждем ли мы drop_user_id для текущей страницы?
            if (this.shouldWaitForDropId && this.drop_user_id === null) {
                console.log('⏳ Ждем drop_user_id для страницы DropProfileSettingsPage...');
                return;
            }
            
            // Для дроп-пользователей всегда нужен profileId
            if (!this.admin_orders && !this.profileId) {
                console.log('⚠️ Ожидание profileId для дроп-пользователя...');
                return;
            }
            
            this.loading = true;

            try {
                // Подготавливаем параметры запроса
                const params = {
                    page: this.currentPage,
                    page_size: this.pageSize,
                    ...this.filters
                };

                // Убираем параметр all_time
                if (params.period === 'all_time') {
                    delete params.period;
                }

                // Добавляем drop_user_id если он задан
                if (this.drop_user_id !== null && this.drop_user_id !== undefined) {
                    params.drop_user_id = this.drop_user_id;
                    console.log('✅ Используем drop_user_id:', this.drop_user_id);
                }

                let response;
                
                if (this.admin_orders) {
                    // Админский режим
                    console.log('📤 Запрос к /manager/orders с параметрами:', params);
                    response = await api.get('/manager/orders', {
                        params: params
                    });
                } else {
                    // Режим дроп-пользователя
                    response = await api.get(`/drop/profile/orders/${this.profileId}`, {
                        params: params
                    });
                }

                console.log('📥 Ответ от сервера:', response.data);
                const newOrders = response.data.orders;

                if (newOrders.length > 0) {
                    this.orders.push(...newOrders);
                    this.currentPage++;
                }

                this.hasMore = this.currentPage <= response.data.total_pages;

                this.$nextTick(() => {
                    this.observeLastElement();
                });

            } catch (error) {
                console.error('Ошибка при загрузке заказов:', error);
                const errorMsg = this.admin_orders ? 
                    'Не удалось загрузить заказы' : 
                    'Не удалось загрузить ваши заказы';
                this.showNotification('error', 'Ошибка загрузки', errorMsg);
            } finally {
                this.loading = false;
            }
        },

        resetAndLoad() {
            this.orders = [];
            this.currentPage = 1;
            this.hasMore = true;
            this.loadingActions = {};
            
            // Загружаем заказы сразу, если не нужно ждать drop_user_id
            if (!this.shouldWaitForDropId) {
                this.loadOrders();
            } else {
                // Если нужно ждать drop_user_id, проверяем, есть ли он
                if (this.drop_user_id !== null) {
                    this.loadOrders();
                } else {
                    console.log('⏸️ Ожидаем drop_user_id для загрузки заказов');
                }
            }
        },

        getStatusText(status) {
            const statusMap = {
                'waiting_confirmation': 'Ожидает подтверждения',
                'waiting_shipment': 'Ожидает отправки',
                'in_transit': 'В пути',
                'delivered_in_pvz': 'Доставлен в ПВЗ',
                'payout_wait': 'Ожидает выплаты',
                'on_return': 'Возврат',
                'return_closed': 'Закрыт после возврата',
                'disputed': 'Спор',
                'finished': 'Завершен',
                'canceled': 'Отменен',
                'waiting_order': 'Ожидает заказа',
                'ordered': 'Заказан',
                'in_china': 'Прибыл на распределительный пункт',
                'transit_to_rf': 'Отправлено в РФ',
                'in_rf': 'Прибыл в РФ'
            };
            return statusMap[status] || status;
        }
    }
};
</script>

<style scoped>
/* Стили остаются без изменений */
.drop-orders-container {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
}

.drop-order-block {
    display: grid;
    grid-template-columns: 1fr 2fr;
    gap: 1.5vw;
    background-color: rgba(255, 255, 255, 0.08);
    height: 45vw;
    border-radius: 10px;
    margin-top: 1.5vw;
    padding: 2vw;
    position: relative;
}

.drop-order-product-img {
    width: 100%;
    height: 41vw;
    border-radius: 10px;
    object-fit: cover;
}

.drop-orders-data {
    display: flex;
    flex-direction: column;
    color: white;
    font-size: 10px;
}

.drop-orders-data-line {
    display: flex;
    gap: 1vw;
    line-height: 1.3;
}

.drop-info-line {
    background-color: rgba(0, 90, 218, 0.1);
    padding: 0.2vw;
    border-radius: 5px;
    margin-bottom: .5vw;
}

.drop-order-data-label {
    color: #005ADA;
    min-width: 10vw;
    font-weight: 500;
}

.drop-order-data-value {
    flex: 1;
    word-break: break-word;
}

.drop-username {
    color: #0BDA51;
    font-size: 0.9em;
}

.payment-paid {
    color: #0BDA51;
    font-weight: bold;
}

.payment-not-paid {
    color: #F71B47;
    font-weight: bold;
}

.buttons-block {
    display: flex;
    gap: 1vw;
    position: absolute;
    right: 0;
    bottom: 0;
}

.buttons-block div {
    border-radius: 10px;
    width: 27vw;
    height: 8vw;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;
    font-size: 3.5vw;
    font-weight: 500;
    user-select: none;
}

.buttons-block div:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.buttons-block div:active:not(:disabled) {
    transform: translateY(0);
}

.buttons-block div:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
}

.return-order {
    background-color: #F2912E;
}

.return-order:hover:not(:disabled) {
    background-color: #e5821e;
}

.canseled-order {
    background-color: #F71B47;
}

.canseled-order:hover:not(:disabled) {
    background-color: #e50a33;
}

.accept-order {
    background-color: #0BDA51;
}

.size-change-floating {
    position: absolute;
    right: 2vw;
    top: 2vw;
    width: 8vw !important;
    min-width: 8vw;
    height: 8vw !important;
    border-radius: 50% !important;
    background: rgba(255, 255, 255, 0.12);
    border: 1px solid rgba(255, 255, 255, 0.24);
    font-size: 4vw !important;
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;
    z-index: 3;
}

.size-change-floating:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.2);
}

.size-modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.65);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 3000;
    padding: 4vw;
}

.size-modal-card {
    width: 100%;
    max-width: 560px;
    border-radius: 18px;
    background: #1d1f23;
    border: 1px solid rgba(255, 255, 255, 0.12);
    box-shadow: 0 18px 50px rgba(0, 0, 0, 0.45);
    color: white;
    padding: 18px;
}

.size-modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
}

.size-modal-title {
    font-size: 18px;
    font-weight: 600;
}

.size-modal-close {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    border: 1px solid rgba(255, 255, 255, 0.18);
    background: rgba(255, 255, 255, 0.08);
    color: white;
}

.size-modal-order {
    display: grid;
    gap: 6px;
    padding: 12px;
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.05);
    margin-bottom: 12px;
    font-size: 13px;
}

.size-modal-options {
    display: grid;
    gap: 8px;
    max-height: 42vh;
    overflow-y: auto;
}

.size-option-btn {
    border: 1px solid rgba(255, 255, 255, 0.14);
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.04);
    color: white;
    padding: 12px 14px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
}

.size-option-selected {
    border-color: #2AABEE;
    background: rgba(42, 171, 238, 0.2);
}

.size-modal-actions {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    margin-top: 14px;
}

.size-modal-cancel,
.size-modal-confirm {
    height: 42px;
    border-radius: 12px;
    border: none;
    color: white;
    font-size: 14px;
    font-weight: 600;
}

.size-modal-cancel {
    background: rgba(255, 255, 255, 0.16);
}

.size-modal-confirm {
    background: #0BDA51;
}

.loading-indicator {
    text-align: center;
    padding: 2vw;
    color: #005ADA;
    font-size: 14px;
}

.end-of-list {
    text-align: center;
    padding: 2vw;
    color: rgba(255, 255, 255, 0.5);
    font-size: 12px;
}

.no-orders {
    text-align: center;
    padding: 4vw;
    color: rgba(255, 255, 255, 0.5);
    font-size: 14px;
}
</style>
